const $doc = $(document);

function checkPasswordMatch() {
	const errorClass = 'form__row--error';
	const $errorMsg = $('.form__row--error-message');
	const $passwordRows = $('#create_customer .form__row').has(
		'input[type="password"]'
	);
	let password = $('#field-password').val();
	let confirmPassword = $('#field-verify').val();

	if (
		password != confirmPassword &&
		password.length > 0 &&
		confirmPassword.length > 0
	) {
		$passwordRows.addClass(errorClass);

		$('.form--register .form__btn').prop('disabled', true);

		$errorMsg.show();
	} else {
		$passwordRows.removeClass(errorClass);

		$('.form--register .form__btn').prop('disabled', false);

		// $('.form--register .fields input[type="password"]').val(password);

		$errorMsg.hide();
	}
}

$doc.on('keyup', function() {
	if (
		$('#create_customer').length &&
		!$('body').hasClass('template-account')
	) {
		checkPasswordMatch();
	}
});
